import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import App from './App';
import store from './store';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://hackerbro-backend-new.onrender.com/';

const curUser = JSON.parse(localStorage.getItem('curUser'));
if (curUser?.token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${curUser.token}`;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <ToastContainer position='bottom-right' autoClose={1500} />
  </Provider>
);
